var _path, _path2, _g, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmptyContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 68,
    viewBox: "0 0 66 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 67.5C43.464 67.5 56 54.964 56 39.5C56 24.036 43.464 11.5 28 11.5C12.536 11.5 0 24.036 0 39.5C0 54.964 12.536 67.5 28 67.5Z",
    fill: "#FDBD90"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_2035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 15,
    width: 48,
    height: 49
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63.5C41.2548 63.5 52 52.7548 52 39.5C52 26.2452 41.2548 15.5 28 15.5C14.7452 15.5 4 26.2452 4 39.5C4 52.7548 14.7452 63.5 28 63.5Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 38.5C32.6421 38.5 36 35.1421 36 31C36 26.8579 32.6421 23.5 28.5 23.5C24.3579 23.5 21 26.8579 21 31C21 35.1421 24.3579 38.5 28.5 38.5Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 73.5C37.3888 73.5 45 65.8888 45 56.5C45 47.1112 37.3888 39.5 28 39.5C18.6112 39.5 11 47.1112 11 56.5C11 65.8888 18.6112 73.5 28 73.5Z",
    fill: "#FF7D23"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 14,
    r: 13.5,
    fill: "#E62645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0527 13.5265C58.0527 12.9713 57.6026 12.5212 57.0474 12.5212L54.0318 12.5212L54.0318 9.50532C54.0318 8.9501 53.5817 8.5 53.0264 8.5C52.4712 8.5 52.0211 8.9501 52.0211 9.50532L52.0211 12.5212L49.0048 12.5212C48.4496 12.5212 47.9995 12.9713 47.9995 13.5265C47.9995 14.0817 48.4496 14.5318 49.0048 14.5318L52.0211 14.5318L52.0211 17.5479C52.0211 18.1031 52.4712 18.5532 53.0264 18.5532C53.5817 18.5532 54.0318 18.1031 54.0318 17.5479L54.0318 14.5318L57.0474 14.5318C57.6026 14.5318 58.0527 14.0817 58.0527 13.5265Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyContacts);
export default __webpack_public_path__ + "static/media/icon_empty_contacts.539727fba48cbe841469a4c0b15a5a37.svg";
export { ForwardRef as ReactComponent };